export const es = {
  common: {
    meta: {
      title: "Hey Jerry | Tu dinero, más claro, más tuyo.",
    },
    actions: {
      add: "Agregar",
      cancel: "Cancelar",
      close: "Cerrar",
      create: "Crear",
      delete: "Eliminar",
      duplicate: "Duplicar",
      edit: "Editar",
      save: "Guardar",
      search: "Buscar",
      clear: "Limpiar",
      update: "Actualizar",
      view: "Ver",
      confirm: "Confirmar",
      logout: "Cerrar sesión",
      profile: "Perfil",
      open: "Abrir",
      select: "Seleccionar",
      showPassword: "Mostrar contraseña",
      hidePassword: "Ocultar contraseña",
      unselect: "Deseleccionar",
    },
    labels: {
      account: "Cuenta",
      accounts: "Cuentas",
      greeting: "Hey,",
      cycle: "Ciclo",
      amount: "Monto",
      balance: "Balance",
      budget: "Presupuesto",
      category: "Categoría",
      categories: "Categorías",
      installment: "Cuota",
      installments: "Cuotas",
      date: "Fecha",
      description: "Descripción",
      email: "Correo",
      endDate: "Fecha final",
      firstName: "Nombre",
      inflow: "Ingreso",
      language: "Idioma",
      lastName: "Apellido",
      name: "Nombre",
      count: "Cantidad",
      net: "Neto",
      outflow: "Gasto",
      perMonth: "{{amount}}/mes",
      password: "Contraseña",
      snapshot: "Resumen",
      savings: "Ahorros",
      startDate: "Fecha inicial",
      currentBalance: "Balance actual",
      required: "Requerido",
      optional: "Opcional",
      tag: "Tag",
      tags: "Tags",
      theme: "Tema",
      total: "Total",
      transaction: "Movimiento",
      transactions: "Movimientos",
      type: "Tipo",
    },
    unknown: "Desconocido",
    untitled: "Sin título",
    states: {
      creating: "Creando...",
      loading: "Cargando...",
      redirecting: "Redirigiendo...",
      saving: "Guardando...",
      deleting: "Eliminando...",
      signingIn: "Ingresando...",
    },
    prompts: {
      closeModal: "Cerrar modal",
      cannotUndo: "Esta acción no se puede deshacer.",
      deleteAccount: "¿Seguro que quieres eliminar esta cuenta? Esta acción no se puede deshacer.",
      deleteBudget: "¿Seguro que quieres eliminar este presupuesto? Esta acción no se puede deshacer.",
      deleteCategory: "¿Seguro que quieres eliminar esta categoría? Esta acción no se puede deshacer.",
      deleteInstallment: "¿Seguro que quieres eliminar esta cuota? Esta acción no se puede deshacer.",
      deleteSaving: "¿Seguro que quieres eliminar esta meta de ahorro? Esta acción no se puede deshacer.",
      deleteTag: "¿Seguro que quieres eliminar este tag? Esta acción no se puede deshacer.",
      deleteTransaction: "¿Seguro que quieres eliminar este movimiento? Esta acción no se puede deshacer.",
      fillRequiredFields: "Por favor completa todos los campos requeridos",
      passwordMismatch: "Las contraseñas no coinciden.",
      pickItemToAdd: "Qué quieres crear?",
    },
    errors: {
      couldNotCreateItem: "No se pudo crear elemento",
      createAccount: "Error al crear la cuenta. Intenta otra vez.",
      createMovement: "No se pudo crear movimiento.",
      deleteAccount: "No se pudo eliminar la cuenta. Intenta otra vez.",
      deleteInstallment: "No se pudo eliminar la cuota. Intenta otra vez.",
      deleteCategory: "No se pudo eliminar la categoría. Intenta otra vez.",
      deleteSaving: "No se pudo eliminar la meta de ahorro. Intenta otra vez.",
      deleteTag: "No se pudo eliminar el tag. Intenta otra vez.",
      destinationMustDiffer: "Cuenta destino debe ser distinta a cuenta origen.",
      generic: "Algo salió mal. Intenta otra vez.",
      invalidCredentials: "Credenciales inválidas. Intenta otra vez.",
      missingAuthTokenTitle: "Falta token de autenticación",
      missingAuthTokenBody: "Pareces autenticado pero no hay token disponible. Cierra sesión e ingresa otra vez.",
      boundaryTitle: "Algo salió mal",
      boundaryBody: "Ocurrió un error inesperado. Recargar la página suele resolverlo.",
      reloadPage: "Recargar página",
      selectedAccountNotFound: "No se encontró cuenta seleccionada.",
      selectedDestinationAccountNotFound: "No se encontró cuenta destino seleccionada.",
      transferDestinationRequired: "Selecciona cuenta destino para transferencias.",
    },
    createLabels: {
      savingsGoal: "Meta de ahorro",
      savingPockets: "Apartado de ahorro",
    },
    createDescriptions: {
      account: "Banco, tarjeta o efectivo",
      budget: "Límite para una categoría",
      category: "Agrupa tus gastos",
      installment: "Pago futuro o recurrente",
      saving: "Objetivo para ahorrar",
      savingPockets: "Gestión de instituciones y apartados",
      tag: "Marca patrones o contexto",
      transaction: "Ingreso, gasto o transferencia",
    },
    filters: {
      accounts: "Cuentas",
      allCycles: "Todo",
      categories: "Categorías",
      installment: "Cuotas",
      currentCycle: "Actual",
      customRange: "Personalizado",
      lastCycle: "Anterior",
      savings: "Ahorros",
      search: "Buscar",
      tags: "Tags",
      transactions: "Movimientos",
    },
    empty: {
      noInstallment: "Sin cuota",
      noSavings: "Sin ahorro",
      uncategorized: "Sin categoría",
      untagged: "Sin tag",
      user: "Usuario",
    },
    periods: {
      thisMonth: "Actual",
      lastMonth: "Anterior",
      custom: "Personalizado",
    },
    theme: {
      dark: "Oscuro",
      light: "Claro",
      system: "Sistema",
      shortDark: "O",
      shortLight: "C",
      shortSystem: "S",
    },
    language: {
      english: "English",
      spanish: "Español",
    },
    navigation: {
      primaryNavigation: "Navegación principal",
      userMenu: "Menú de cuenta",
      navigate: "Navegar",
      current: "Actual: {{label}}",
      chooseDestination: "Elige destino",
      openNavigationMenu: "Abrir menú de navegación",
      closeNavigationMenu: "Cerrar menú de navegación",
      mobileNavigation: "Navegación móvil",
      mobileNavigationMenu: "Menú de navegación móvil",
      themeMode: "Modo de tema",
      languageMode: "Selector de idioma",
      createMenu: "Menú de crear",
      closeCreateMenu: "Cerrar menú de crear",
      openCreateMenu: "Abrir menú de crear",
      quickTransaction: "Crear movimiento rápido",
    },
    dialogs: {
      confirmAction: "Confirmar acción",
      confirmDeletion: "Confirmar eliminación",
    },
    aria: {
      cancelSelection: "Cancelar selección",
      close: "Cerrar",
      deleteItem: "Eliminar {{name}}",
      duplicateTransactions: "Duplicar {{count}} movimientos",
      editItem: "Editar {{name}}",
      goToFirstPage: "Ir a primera página",
      goToSecondPage: "Ir a segunda página",
      openItem: "Abrir {{name}}",
      selectAllVisible: "Seleccionar todos los movimientos visibles",
      selectItem: "Seleccionar {{name}}",
      unselectItem: "Deseleccionar {{name}}",
      updateTransactions: "Actualizar {{count}} movimientos",
      viewItem: "Ver {{name}}",
      viewTicketFor: "Ver ticket de {{name}}",
    },
  },
  profile: {
    mcp: {
      eyebrow: "Acceso de agentes",
      title: "Conectar Jerry",
      description: "Conecta un agente de IA para consultar tus datos financieros de Hey Jerry. OAuth es el método recomendado; los tokens personales sirven para configuración manual.",
      oauthTitle: "Conectar con OAuth",
      oauthDescription: "Tu agente puede solicitar acceso y tú revisas y apruebas permisos de solo lectura en Hey Jerry. El agente se encarga de renovar el acceso. La configuración OAuth aparecerá aquí cuando tu agente inicie la conexión.",
      downloadSkill: "Descargar paquete de skill de Hey Jerry · v{{version}}",
      packageLoading: "Cargando el paquete del agente…",
      packageError: "El paquete del agente no está disponible en este entorno.",
      manualTitle: "Token personal · configuración manual",
      manualDescription: "Úsalo solo con un cliente que no admita OAuth. El token permite lectura hasta que venza o lo revoques.",
      label: "Nombre del cliente",
      labelPlaceholder: "Por ejemplo, Claude Desktop",
      expiry: "Vigencia del token",
      days: "{{count}} días",
      create: "Crear token personal",
      loading: "Cargando tokens personales…",
      loadError: "No se pudieron cargar los tokens personales.",
      createError: "No se pudo crear el token. Revisa tu sesión e inténtalo de nuevo.",
      revokeError: "No se pudo revocar el token. Actualiza la lista e inténtalo de nuevo.",
      copyError: "No se pudo copiar. Revisa los permisos del navegador.",
      copied: "Copiado",
      secretOnceTitle: "Guarda este token ahora",
      secretOnceDescription: "Este secreto se muestra una sola vez. Se borra de esta página cuando termines.",
      secretLabel: "Token personal",
      serverUrl: "URL del servidor MCP",
      copyConfig: "Copiar configuración del cliente",
      copySecret: "Copiar token",
      savedSecret: "Ya guardé el token",
      status: "Estado",
      active: "Activo",
      revoked: "Revocado",
      expired: "Vencido",
      expires: "Vence {{date}}",
      lastAuthentication: "Última autenticación: {{date}}",
      never: "Nunca",
      empty: "Aún no hay tokens personales.",
      revoke: "Revocar",
      revokeTitle: "¿Revocar {{label}}?",
      revokeBody: "El cliente perderá el acceso de inmediato. Esta acción no se puede deshacer.",
    },
    mcpConsent: {
      title: "Revisa el acceso del agente",
      description: "Elige si quieres conectar este agente con tu cuenta de Hey Jerry.",
      clientAsks: "Este agente solicita acceso:",
      permissions: "Permisos solicitados",
      resourceHost: "Servicio de Jerry:",
      returnHost: "Destino de regreso del agente:",
      readPermission: "Consultar tus datos financieros en Hey Jerry.",
      renewPermission: "Renovar su conexión mientras el acceso siga vigente.",
      renewalNote: "Puedes revocar esta conexión desde Perfil cuando quieras. El agente renueva el acceso automáticamente mientras la autorización siga activa.",
      approve: "Aprobar conexión",
      deny: "Denegar",
      requestMissing: "La solicitud de conexión está incompleta. Iníciala de nuevo desde tu agente.",
      requestError: "La solicitud venció o no se pudo cargar. Iníciala de nuevo desde tu agente.",
      decisionError: "No se pudo guardar tu decisión. Inténtalo de nuevo.",
      loginReturnError: "No se pudo guardar esta solicitud de forma segura para iniciar sesión. Vuelve a tu agente e inténtalo de nuevo.",
      backToProfile: "Volver al perfil",
      connectionsTitle: "Conexiones de agentes",
      connectionsDescription: "Revisa y revoca conexiones OAuth. La última autenticación no confirma que el agente haya completado una consulta.",
      loading: "Cargando conexiones de agentes…",
      loadError: "No se pudieron cargar las conexiones de agentes.",
      revokeError: "No se pudo revocar la conexión. Actualiza la lista e inténtalo de nuevo.",
      revokeTitle: "¿Revocar {{client}}?",
      revokeBody: "El agente perderá el acceso de inmediato. Podrá volver a conectarse después de solicitar y recibir tu aprobación.",
      revoke: "Revocar conexión",
      status: "Estado",
      active: "Activa",
      revoked: "Revocada",
      expired: "Vencida",
      expires: "Vence {{date}}",
      lastAuthentication: "Última autenticación: {{date}}",
      scopes: "Acceso: {{scopes}}",
      never: "Nunca",
      empty: "Aún no hay conexiones OAuth.",
    },
    title: "Tu perfil",
    subtitle: "Datos cargados desde get user/.",
    refresh: "Actualizar perfil",
    saveProfile: "Guardar cambios",
    changePassword: "Cambiar contraseña",
    deleteAccount: {
      action: "Eliminar cuenta",
      sectionTitle: "Zona de riesgo",
      sectionHint: "Anonimiza tu perfil y cierra todas las sesiones activas.",
      confirmTitle: "¿Eliminar tu cuenta?",
      confirmBody: "Esta acción no se puede deshacer.",
      anonymizationDetail: "Tu nombre, correo y teléfono se anonimizarán.",
      sessionsDetail: "Todas tus sesiones se cerrarán y tendrás que iniciar sesión de nuevo.",
      irreversibleDetail: "Tus cuentas y movimientos se conservarán, pero no podrás recuperar el acceso a esta cuenta.",
      confirm: "Eliminar cuenta",
      error: "No se pudo eliminar la cuenta. Tu sesión sigue activa; intenta otra vez.",
    },
    terms: "Términos y condiciones",
    identity: "Identidad",
    preferences: "Preferencias",
    accountStatus: "Estado de cuenta",
    firstNameFallback: "Sin nombre",
    lastNameFallback: "Sin apellido",
    phoneFallback: "Sin teléfono",
    dateFallback: "Sin fecha",
    active: "Activa",
    inactive: "Inactiva",
    yes: "Sí",
    no: "No",
    fields: {
      id: "ID",
      email: "Correo",
      firstName: "Nombre",
      lastName: "Apellido",
      phone: "Teléfono",
      language: "Idioma",
      theme: "Tema",
      isActive: "Cuenta activa",
      createdAt: "Creada",
      updatedAt: "Actualizada",
      deletedAt: "Eliminada",
    },
    messages: {
      saveSuccess: "Perfil actualizado.",
      saveError: "No se pudo actualizar perfil. Intenta otra vez.",
      passwordSuccess: "Contraseña actualizada.",
      passwordError: "No se pudo cambiar la contraseña. Revisa la contraseña actual.",
    },
    passwordModal: {
      title: "Cambiar contraseña",
      subtitle: "Usa tu contraseña actual para proteger el cambio.",
      oldPassword: "Contraseña actual",
      newPassword: "Nueva contraseña",
      submit: "Guardar contraseña",
      showPassword: "Mostrar contraseña",
      hidePassword: "Ocultar contraseña",
    },
    csvImport: {
      open: "Importar CSV",
      title: "Importar movimientos desde CSV",
      subtitle: "Primero revisaremos el archivo. Nada se crea hasta que confirmes la vista previa.",
      progress: {
        review: "Paso 1 de 2 · Revisar archivo",
        confirm: "Paso 2 de 2 · Confirmar importación",
        complete: "Importación completada",
      },
      formatTitle: "Formato requerido",
      formatDisclosure: "Ver formato requerido",
      ruleEncoding: "Archivo .csv codificado en UTF-8.",
      ruleHeaders: "Encabezados exactos y en minúsculas: date, name, amount, type, account. Opcionales: category, description, external_id.",
      ruleValues: "Fecha YYYY-MM-DD; monto positivo con hasta 2 decimales; type debe ser DEPOSIT o EXPENSE.",
      ruleNames: "account y category deben coincidir exactamente con cuentas y categorías existentes. category puede quedar vacía.",
      ruleLimit: "Máximo 5,000 filas y 2 MiB. No agregues columnas ni repitas encabezados.",
      selectFile: "Selecciona archivo CSV",
      fileHint: "Solo .csv, hasta 2 MiB",
      browse: "Explorar",
      preview: "Revisar CSV",
      confirm: "Confirmar importación",
      cancel: "Cancelar",
      close: "Cerrar",
      previewReady: "Archivo válido. Revisa resumen y confirma para crear movimientos.",
      complete: "Importación terminada: {{created}} movimientos creados; {{duplicates}} duplicados omitidos.",
      summary: "{{rows}} filas encontradas · {{valid}} válidas · {{errors}} con error",
      rowError: "Línea {{line}} · {{field}}: {{message}}",
      errors: { fileType: "Selecciona un archivo .csv.", fileSize: "El archivo no puede superar 2 MiB.", preview: "No se pudo revisar el CSV.", confirm: "No se pudo confirmar la importación." },
    },
    appMode: {
      label: "Modo de la app",
      ariaLabel: "Selector de modo de la app",
      simple: {
        label: "Modo simple",
        description: "Muestra lo esencial para consultar y registrar tu dinero con menos opciones visibles.",
        ariaLabel: "Elegir modo simple: muestra funciones esenciales y menos opciones visibles",
      },
      advanced: {
        label: "Modo avanzado",
        description: "Muestra herramientas y controles adicionales para gestionar tu dinero con más detalle.",
        ariaLabel: "Elegir modo avanzado: muestra herramientas y controles adicionales",
      },
    },
    status: {
      complete: "Completo",
      inProgress: "En progreso",
      needsAttention: "Requiere atención",
    },
    fieldState: {
      ready: "Listo",
      missing: "Falta",
    },
    summary: {
      heroNote: "Ajustes tranquilos, siempre a la mano.",
      profileStrength: "Fuerza del perfil",
      memberSince: "Miembro desde",
      lastSync: "Última sincronización",
      profileEditor: "Editor de perfil",
      editorHint: "Mantén tus datos al día para que el contexto de la cuenta siga limpio en toda la app.",
      unsavedChanges: "Tienes cambios sin guardar.",
      synced: "Todo está sincronizado.",
      environment: "Controles del espacio",
      preferencesHint: "Idioma y tema viven aquí, separados de tus datos personales.",
      experience: "Nivel de la app",
      experienceHint: "Define cuántas herramientas y opciones muestra la app en todas las vistas.",
      systemSnapshot: "Estado del sistema",
      accountTimeline: "Línea de cuenta",
      lastUpdated: "Última actualización",
    },
  },
  nav: {
    home: "Inicio",
    planning: "Planear",
    more: "Más",
    homeSubtitle: "Resumen general",
    wrapped: "Resumen mensual",
    wrappedSubtitle: "Tu mes, visto con claridad",
    transactions: "Movimientos",
    transactionsSubtitle: "Ingresos, gastos y transferencias",
    accounts: "Cuentas",
    accountsSubtitle: "Dónde está tu dinero",
    categories: "Categorías",
    categoriesSubtitle: "En qué se fue tu dinero",
    tags: "Tags",
    tagsSubtitle: "Patrones de movimiento",
    savings: "Ahorros",
    savingsSubtitle: "Tus metas",
    savingPockets: "Apartados",
    savingPocketsSubtitle: "Instituciones y apartados",
    budget: "Presupuestos",
    budgetSubtitle: "Límites de gasto",
    installments: "Cuotas",
    installmentsSubtitle: "Pagos futuros",
    analytics: "Analítica",
    analyticsSubtitle: "Gráficas y patrones de flujo",
    profile: "Perfil",
    profileSubtitle: "Tu cuenta y preferencias",
  },
  wrapped: {
    title: "Tu resumen mensual",
    subtitle: "Una mirada clara a cómo se movió tu dinero",
    historyTitle: "Resúmenes anteriores",
    historyEmpty: "Todavía no hay meses para mostrar.",
    unread: "Sin ver",
    loading: "Cargando tu resumen...",
    loadError: "No pudimos cargar tu resumen.",
    pending: "Estamos preparando tu resumen",
    noTransactions: "Necesitas al menos 10 movimientos en el mes para ver tu resumen",
    noActiveDays: "Necesitas movimientos en al menos 5 días del mes",
    noReport: "Todavía no tienes resúmenes. El primero llega a principios del mes que viene",
    previous: "Anterior",
    next: "Siguiente",
    done: "Listo",
    progress: "Pantalla {{current}} de {{total}}",
    income: "Ingresos",
    expenses: "Gastos",
    balance: "Balance",
    spentMore: "Gastaste {{percent}}% más que el mes anterior.",
    spentLess: "Gastaste {{percent}}% menos que el mes anterior.",
    spentSame: "Gastaste lo mismo que el mes anterior.",
    expenseIncomeRatio: "Por cada $1 que ingresó, gastaste {{amount}}.",
    primaryVsIncome: "{{category}} absorbió el {{percent}}% de tus ingresos.",
    categories: "Categorías",
    categoriesEmpty: "No hubo gastos por categoría este mes.",
    recurringCount_one: "Este mes: {{count}} movimiento",
    recurringCount_other: "Este mes: {{count}} movimientos",
    recurringAmount: "Total: {{amount}}",
    averageTicket: "Ticket promedio: {{amount}}",
    previousMonthCount_one: "Mes anterior: {{count}} movimiento",
    previousMonthCount_other: "Mes anterior: {{count}} movimientos",
    budgetsRespected: "Presupuestos respetados",
    budgetsExceeded: "Presupuestos excedidos",
    topBudgetsExceeded: "Mayores excesos de presupuesto",
    budgetsExceededCount_one: "{{count}} de {{total}} presupuesto excedido",
    budgetsExceededCount_other: "{{count}} de {{total}} presupuestos excedidos",
    budgetOverage: "{{excess}} sobre el límite de {{limit}}",
    budgetCounterfactualNegative: "Los excesos sumaron {{excess}}. Aun evitándolos, el balance habría sido {{balance}}.",
    budgetCounterfactualPositive: "Los excesos sumaron {{excess}}. Evitarlos habría llevado el balance a {{balance}}.",
    deposited: "Apartado este mes",
    focusReduce: "Reduce {{category}} en {{amount}} para volver a su límite.",
    focusCloseGap: "Tu primera meta es cerrar una brecha de {{amount}}.",
    focusProtectSurplus: "Protege al menos {{amount}} de tu superávit.",
    focusStillNegative: "Tu balance proyectado sería {{balance}}; todavía faltarían {{gap}} para llegar a cero.",
    focusPositive: "Tu balance proyectado sería {{balance}}.",
    reviewBudgets: "Revisar presupuestos",
    openPeriod: "Abrir resumen de {{period}}",
  },
  auth: {
    brand: {
      kicker: "Hey Jerry",
      headline: "Tu dinero, más claro, más tuyo.",
      subheadline: "Un espacio simple para leer movimientos, metas y hábitos sin ruido visual.",
      previewKicker: "Finance OS",
      previewHeadline: "Tu dinero,\nen orden.",
      previewSubheadline: "Jerry ya ordenó tu mes. Entra para ver cómo vas.",
      previewAlt: "Vista ilustrativa de HeyJerry con un resumen del mes, gastos y una meta de viaje.",
      previewRemaining: "Te quedan",
      previewCycle: "este mes · 12 días para tu corte",
      previewSpending: "Gasto",
      previewSpendingChange: "+8% vs. agosto",
      previewGoal: "Meta · Viaje",
      previewGoalAmount: "$13,600 de $20,000",
    },
    signIn: {
      title: "Entra a tu cuenta",
      subtitle: "Con tu correo y contraseña.",
      submit: "Ingresar",
      forgotPassword: "¿Olvidaste tu contraseña?",
      noAccount: "¿No tienes cuenta?",
      signUpLink: "Crear cuenta",
    },
    signUp: {
      title: "Crear cuenta",
      subtitle: "Escribe tu información para registrarte",
      confirmPassword: "Confirmar contraseña",
      submit: "Crear cuenta",
      hasAccount: "¿Ya tienes cuenta?",
      signInLink: "Ingresar",
      termsPrefix: "Acepto los",
      termsLink: "Términos y condiciones",
      termsRequired: "Debes aceptar los términos y condiciones antes de crear una cuenta.",
    },
  },
  dashboard: {
    loadError: "No se pudo cargar tu panel.",
    greeting: "Hey, {{name}}",
    subtitle: "Así va tu dinero este mes",
    heroPeriod: "este mes",
    heroInflow: "Ingresos {{amount}}",
    heroOutflow: "Gastos {{amount}}",
    insightPositiveAllWeeks: "Vas en positivo todo el ciclo. Hubo más ingresos que gastos cada semana.",
    insightExpenseUp: "Sigues en positivo, pero tu gasto subió {{percentage}}% vs el ciclo pasado.",
    insightPositiveWeeks:
      "Tus ingresos superaron tus gastos en {{count}} de {{total}} semanas.",
    insightNegativeWeek: "Este ciclo se te cargó en {{label}}: ahí hubo más gastos que ingresos.",
    insightNegativeGeneric: "Este ciclo vas por debajo. Vale revisar qué gasto te movió más.",
    controlRate: "Tasa de control",
    ofInflowThisCycle: "del ingreso de este ciclo",
    budgetStatus: "Estado del presupuesto",
    nearLimit: "cerca del límite",
    allBudgetsOnTrack: "Todos los presupuestos van en línea",
    vsPreviousCycle: "vs ciclo anterior",
    positionTrendTitle: "Tendencia de posición",
    positionTrendSubtitle: "Tendencia mensual de tu posición",
    positionTrendEmpty: "No hay datos disponibles",
    cycleNet: "Neto del ciclo",
    currentWeek: "Esta semana",
    emptyWeeksSummary_one: "{{count}} semana sin movimientos · {{weeks}}",
    emptyWeeksSummary_other: "{{count}} semanas sin movimientos · {{weeks}}",
    latest: "Último",
    loadingActivity: "Cargando actividad...",
    noRecentActivityFound: "No se encontró actividad reciente",
    latestActivityAcrossAccounts: "Actividad reciente en todas tus cuentas",
    tableAccount: "Cuenta",
    repeatedTransactionsTitle: "Movimientos repetidos",
    loadingRepeatedTransactions: "Cargando movimientos repetidos...",
    noRepeatedTransactionsFound: "No se encontraron movimientos repetidos",
    repeatedTransactionsSubtitle: "Movimientos ordenados por cantidad de repeticiones",
    transactionCountShort: "movs",
    repeatedCount: "Repetida {{count}} veces",
    targetProgressTitle: "Progreso de metas",
    loadingSavings: "Cargando ahorros...",
    targetProgressSubtitle: "Sigue tu avance hacia las metas financieras definidas",
    budgetLineTitle: "Línea de presupuesto",
    budgetLineSubtitle: "Presupuestado vs gastado por categoría",
    budgetLineEmpty: "Aún no hay presupuestos para graficar.",
    budgeted: "Presupuestado",
    spent: "Gastado",
    budget: "Presupuesto",
    allocationBreakdownTitle: "Desglose por asignación",
    allocationBreakdownSubtitle: "Desglose del gasto por asignación",
    noDataToDisplay: "No hay datos para mostrar",
    groupedSmallCategories: 'Las categorías pequeñas se agruparon en "Otros" para mantener la vista legible.',
    othersLabel: "Otros",
    categoryVsBudgetTitle: "Categoría vs presupuesto",
    spendingInsights: "Insights de gasto",
    budgetHealth: "Salud del presupuesto",
    expenseConcentration: "Concentración del gasto",
    good: "Bien",
    overBudget: "Sobre presupuesto",
    lowShare: "Participación baja",
    mediumShare: "Participación media",
    dominantShare: "Participación dominante",
    loadingHeatmap: "Cargando mapa de calor...",
    noMonthlyCategoryData: "Aún no hay datos mensuales por categoría para graficar.",
    suggested: "Sugerido",
    totalMonthlySpending: "Gasto mensual total",
    shareOfMonthlySpending: "Participación del gasto mensual",
    inflowLabel: "Ingresos",
    outflowLabel: "Gastos",
    noChartData: "Aún no hay suficiente movimiento para comparar ingresos y gastos.",
    breakdownTitle: "Dónde se fue",
    breakdownBody: "Las categorías que más peso tuvieron en tu gasto.",
    noBreakdownData: "Todavía no hay categorías con gasto este ciclo.",
    activityTitle: "Actividad reciente",
    activityBody: "Tus últimos movimientos, sin ruido.",
    activityToday: "Hoy",
    activityYesterday: "Ayer",
    activityThisWeek: "Esta semana",
    activityEarlier: "Antes",
    activityTypeInflow: "Ingreso",
    activityTypeOutflow: "Gasto",
    noRecentActivity: "Aún no hay movimientos recientes.",
    viewAllActivity: "Ver toda la actividad",
    customize: "Personalizar inicio",
    customizeShort: "Personalizar",
    customizeDescription: "Elige qué paneles aparecen, cómo empiezan y define su orden.",
    panelOpenOnLoad: "Mostrar abierto",
    showPanel: "Mostrar {{panel}}",
    hidePanel: "Ocultar {{panel}}",
    movePanelUp: "Subir {{panel}}",
    movePanelDown: "Bajar {{panel}}",
    noVisiblePanels: "No hay paneles visibles. Usa Personalizar inicio para mostrar uno.",
    glanceTitle: "Tu ciclo de un vistazo",
    glanceBudgets: "Presupuestos",
    glanceBudgetUsed: "{{percent}}% usado",
    glanceGoal: "Meta principal",
    glanceTopCategory: "Lo que más pesó",
    shareOfSpendingSuffix: "de tu gasto",
    breakdownOverline: "Categorías · {{period}}",
    viewAllRepeated: "Ver todo",
    collapseSection: "Contraer {{section}}",
    expandSection: "Expandir {{section}}",
    positionTrendDescribe:
      "Tendencia mensual de tu posición: {{firstMonth}} {{firstValue}}, máximo {{highMonth}} {{highValue}}, último {{latestMonth}} {{latestValue}}.",
    positionTrendRole: "gráfico",
    positionTrendKeyboardHint: "Usa las flechas para recorrer los meses.",
    positionTrendMonthValue: "{{month}}: {{value}}",
    toolbarLabel: "Ciclo y personalizar inicio",
  },
  accounts: {
    loadError: "No se pudieron cargar tus cuentas.",
    title: "Hey, Cuentas!",
    subtitle: "Dónde está tu dinero",
    addFirst: "Agrega tu primera cuenta",
    largestPosition: "Mayor posición",
    highestIncomeSource: "Mayor fuente de ingreso",
    highestOutflowAccount: "Cuenta con mayor gasto",
    editTitle: "Editar cuenta",
    createTitle: "Crear cuenta",
    editSubtitle: "Actualiza la información de tu cuenta",
    createSubtitle: "Débito, crédito o efectivo",
    mainSection: "Principal",
    customizationSection: "Personalización",
    colorLabel: "Color",
    colorHelp: "Si no eliges, usamos el color del tipo de cuenta. Se marca con check, no solo con color.",
    colorsLoading: "Cargando colores...",
    colorsLoadError: "No se pudieron cargar los colores.",
    colorNames: { mist: "Menta", sun: "Sol", lilac: "Lila", lime: "Lima", rose: "Rosa", flame: "Fuego" },
    logoutAgain: "Cerrar sesión e ingresar otra vez",
    noAccountBalanceYet: "Aún no hay balance de cuenta",
    noInflowRecorded: "Aún no hay ingresos",
    noOutflowRecorded: "Aún no hay gastos",
    totalPosition: "Posición total",
    haveNow: "A favor del ciclo",
    oweNow: "En contra del ciclo",
    balanceCycleTotal: "Balance total del ciclo",
    balanceToday: "Balance total · hoy",
    balanceAvailable: "Saldo disponible",
    balanceCycle: "Balance del ciclo",
    balanceDebt: "Deuda actual",
    balanceCash: "En tu cartera",
    creditDetailsTitle: "Detalles de crédito",
    creditDetailsHelp: "Agrega los datos del ciclo y de pago de tu línea de crédito.",
    creditLimitLabel: "Límite de crédito",
    creditLimitHelp: "Monto total disponible en tu línea.",
    billingCycleDayLabel: "Día de corte",
    billingCycleDayHelp: "Día del mes en que se cierra tu ciclo.",
    paymentDueDaysLabel: "Días para pagar",
    paymentDueDaysHelp: "Días entre el corte y la fecha límite de pago.",
    accountNameRequired: "Escribe un nombre para la cuenta.",
    accountTypePlaceholder: "Elige un tipo",
    accountTypeRequired: "Elige el tipo de cuenta.",
    creditFieldsRequired: "Completa los datos de crédito.",
    billingCycleDayRange: "El día de corte debe estar entre 1 y 31.",
    paymentDueDaysRange: "Los días para pagar deben estar entre 1 y 60.",
    noAccountsFound: "No se encontraron cuentas",
    emptyStateBody: "Tus cuentas van a aparecer aquí. Agrega una y podrás ver rápido dónde está tu dinero.",
    heroContext: "en tus cuentas",
    heroCycleNet: "este ciclo",
    flowSummary: "Ingresos {{inflow}} • Gastos {{outflow}}",
    insightDominant: "{{name}} concentra tu dinero",
    insightGrowing: "{{name}} es tu cuenta principal y va creciendo",
    insightWatching: "{{name}} sigue siendo tu cuenta principal, pero este ciclo se movió a la baja",
    insightLargest: "{{name}} concentra la mayor parte de tu balance",
    dominantHighlight: "Representa {{percent}}% del total",
    noChanges: "Sin cambios",
    listTitle: "Tus cuentas",
    noDescription: "Sin descripción",
    itemFlowSummary: "Ingresos {{inflow}} • Gastos {{outflow}}",
    flowIncome: "Ingresos",
    flowExpense: "Gastos",
    rowAccessibleLabel: "{{name}}, {{type}}, ingresos {{income}}, gastos {{expense}}, saldo {{balance}}. {{credit}}",
    creditAccessibleSummary: "Cupo disponible {{available}}. {{usage}}",
    accountMenuLabel: "Más opciones de {{name}}",
    creditUsagePercent: "{{percent}}% del límite",
    creditUsageValueText: "{{percent}}% del límite usado",
    inactiveTitle: "Sin saldo",
    viewAll: "Ver todas",
    accountTypeFallback: "Cuenta",
    sortByLabel: "Ordenar por",
    sortDirectionLabel: "Dirección",
    sortByName: "Nombre",
    sortByAmount: "Monto",
    sortAscending: "Ascendente",
    sortDescending: "Descendente",
    tableTitle: "Tabla de cuentas",
    countLabel: "{{count}} cuentas",
    activity: "actividad",
    monthlyNet: "Neto mensual",
    activityShare: "Participación de actividad",
    currentMonthlyActivity: "{{percent}}% de actividad mensual actual",
    availableCredit: "Cupo disponible",
    availableCreditOf: "Disponible {{available}} de {{limit}}",
    creditUsage: "{{used}} usado de {{limit}} de límite total",
    creditUsedPercent: "Usaste {{percent}}%",
    creditCutDate: "Corte {{date}}",
    creditPaymentDate: "Pago {{date}}",
    deletionImpact: {
      previewError: "No se pudo consultar cuántos movimientos se eliminarían. Intenta otra vez.",
      transactions_one: "Se eliminará {{count}} movimiento",
      transactions_other: "Se eliminarán {{count}} movimientos",
      transfers_one: "Se eliminará {{count}} transferencia hacia esta cuenta",
      transfers_other: "Se eliminarán {{count}} transferencias hacia esta cuenta",
      installments_one: "Se eliminará {{count}} compromiso",
      installments_other: "Se eliminarán {{count}} compromisos",
      importRows_one: "Se desvinculará {{count}} fila importada",
      importRows_other: "Se desvincularán {{count}} filas importadas",
    },
  },
  categories: {
    iconsLoading: "Cargando iconos…",
    iconsLoadError: "No se pudieron cargar los iconos.",
    iconPickerTitle: "Elegir icono",
    iconPickerSubtitle: "{{count}} iconos · busca o explora por grupo",
    useIcon: "Usar este icono",
    searchIcon: "Buscar icono",
    searchIconPlaceholder: "Buscar icono: casa, café, gym…",
    iconGroups: "Grupos de iconos",
    searchResults: "Resultados de búsqueda",
    noIcons: "No encontramos «{{query}}»",
    noIconsHint: "Prueba con otra palabra, como «casa» o «café», o explora por grupo.",
    showIcons: "Ver todos los iconos",
    iconCount: "{{count}} iconos",
    chosenIcon: "Elegido: {{name}}",
    noIcon: "Sin icono · usamos Otros",
    clearIcon: "Sin icono",
    saveChanges: "Guardar cambios",
    changesSaved: "Cambios guardados",
    categoryCreated: "Categoría {{name}} creada",
    editSubtitle: "Cambia el nombre, el color o el icono",
    createSubtitle: "Agrupa tus movimientos",
    nameLabel: "Nombre",
    nameRequired: "Ponle un nombre a tu categoría",
    namePlaceholder: "Ej. Gym, Mascotas, Café",
    previewName: "Tu categoría",
    previewCaption: "Así se verá en tus categorías",
    iconLabel: "Icono",
    principalSection: "Principal",
    customizationSection: "Personalización",
    colorsLoading: "Cargando colores…",
    colorsLoadError: "No se pudieron cargar los colores.",
    noColor: "Sin color",
    colorHelp: "Elige un color para reconocer tu categoría de un vistazo.",
    saveError: "No se pudo guardar la categoría. Revisa los datos e intenta de nuevo.",
    viewMovements: "Ver movimientos",
    editCategory: "Editar categoría",
    deleteCategory: "Eliminar categoría",

    loadError: "No se pudieron cargar tus categorías.",
    title: "Hey, Categorías!",
    subtitle: "Así se fue tu dinero",
    loading: "Cargando asignaciones...",
    topSpendingCategory: "Categoría con mayor gasto",
    highestIncomeSource: "Fuente con mayor ingreso",
    outflowConcentration: "Concentración de gasto",
    outflowConcentrationValue: "{{count}} categorías mueven 75% del gasto",
    noConcentrationData: "Aún no hay datos de concentración",
    noAllocationsFound: "No se encontraron asignaciones",
    addFirstAllocation: "Agrega tu primera asignación",
    heroLabel: "Lo que más te pesó",
    emptyHero: "Aún sin gasto",
    ofSpending: "del gasto",
    ofIncome: "del ingreso",
    noSpendingYet: "Todavía no hay gasto suficiente para leer un patrón.",
    insightDominant: "La mayor parte de tu gasto fue a {{name}}",
    insightLeading: "{{name}} se llevó la parte más grande de tu gasto",
    insightSpread: "Tu gasto está más repartido entre varias categorías",
    distributionTitle: "Tus gastos",
    listTitle: "Categorías",
    latestCategoriesSubtitle: "Revisa tus categorías más recientes",
    noDescription: "Sin descripción",
    othersLabel: "Otros",
    countLabel: "{{count}} categorías",
    activeCountPeriodLabel: "{{count}} categorías activas este periodo",
    inactiveTitle: "Sin movimiento",
    viewAll: "Ver todas",
    emptyStateBody: "Tus categorías van a aparecer aquí cuando empieces a mover gasto.",
  },
  tags: {
    saveChanges: "Guardar cambios",
    changesSaved: "Cambios guardados",
    tagCreated: "Tag {{name}} creado",
    editSubtitle: "Cambia el nombre, la descripción, el color o el icono",
    createSubtitle: "Etiqueta tus movimientos",
    nameLabel: "Nombre",
    nameRequired: "Ponle un nombre a tu tag",
    namePlaceholder: "Ej. Fijo, Vacaciones, Trabajo",
    previewName: "Tu tag",
    previewCaption: "Así se verá en tus tags",
    iconLabel: "Icono",
    principalSection: "Principal",
    customizationSection: "Personalización",
    colorsLoading: "Cargando colores…",
    colorsLoadError: "No se pudieron cargar los colores.",
    noColor: "Sin color",
    saveError: "No se pudo guardar el tag. Revisa los datos e intenta de nuevo.",

    mainTag: "Tag principal",
    taggedShare: "de tus gastos taggeados",
    searchPlaceholder: "Buscar tag",
    yourTags: "Tus tags",
    visibleCount: "{{count}} tags",
    showActions: "Acciones del tag",
    newTag: "Nuevo",

    loadError: "No se pudieron cargar tus tags.",
    title: "Hey, Tags!",
    subtitle: "Cómo se mueve tu dinero",
    segmentAll: "Todo",
    segmentCurrent: "Actual",
    segmentPrevious: "Anterior",
    loading: "Cargando tags...",
    topSpendingTag: "Tag con mayor gasto",
    highestIncomeTag: "Tag con mayor ingreso",
    outflowConcentration: "Concentración de gasto",
    outflowConcentrationValue: "{{count}} tags mueven 75% del gasto",
    noConcentrationData: "Aún no hay datos de concentración",
    heroLabel: "Lo que más domina",
    heroMovementContext: "en dinero etiquetado",
    heroDominantContext: "{{name}} representa el {{percent}}% del movimiento etiquetado",
    emptyHero: "Sin patrón todavía",
    ofSpending: "de tu gasto",
    noBehaviorYet: "Aún no hay suficientes movimientos para leer un patrón.",
    insightMsi: "Gran parte de tu gasto está en pagos a meses",
    insightRecurring: "Tus gastos recurrentes están pesando más este ciclo",
    insightDominant: "{{name}} representa una gran parte del movimiento etiquetado",
    insightDominantShort: "El tag {{name}} concentra casi todo el movimiento.",
    insightLeading: "{{name}} marca el patrón más fuerte de este ciclo",
    insightSplitRecommendation: "Divide {{name}} en tags más específicos para ver mejor el detalle.",
    behaviorHighlight: "{{name}} representa {{percent}}% de cómo estás gastando",
    behaviorBalanced: "Tu comportamiento está más repartido entre varios tags",
    distributionTitle: "Distribución por tag",
    summaryTitle: "Gastos taggeados",
    untaggedShare: "{{amount}} adicionales sin ningún tag.",
    transactionsPeriod: "Movimientos del tag",
    periodBalance: "Balance del periodo",
    transactionsList: "Movimientos",
    transactionsByCategory: "Por categoría",
    transactionsLoadError: "No se pudieron cargar movimientos.",
    noTransactionsInPeriod: "No hay movimientos en este periodo.",
    transactionsCount: "{{count}} movimientos",
    uncategorized: "Sin categoría",
    listTitle: "Tus tags",
    noDescription: "Sin descripción",
    countLabel: "{{count}} tags",
    activeCountLabel: "{{count}} tags con movimiento",
    inactiveTitle: "Sin movimiento",
    inactiveCountLabel: "{{count}} tags sin movimiento",
    viewAll: "Ver todos",
    emptyStateTitle: "Aún no hay movimientos etiquetados",
    emptyStateBody: "Agrega tags a tus transacciones para entender mejor cómo se mueve tu dinero.",
    addFirst: "Crea tu primer tag",
  },
  transactions: {
    tableDate: "Fecha",
    tableMovement: "Movimiento",
    tableTime: "Hora",
    sortNewest: "Ordenados por fecha, más recientes primero",
    tableAmount: "Monto",
    tableActions: "Acciones",
    rowActions: "Acciones de {{name}}",
    showingCount: "{{shown}} de {{total}} movimientos",
    selectMovement: "Seleccionar {{name}}",
    openMovement: "Ver o editar {{name}}",
    allTransactions: "Todo",
    pageTitle: "Hey, Movimientos!",
    pageSubtitle: "Tu actividad reciente",
    activityTitle: "Actividad reciente",
    activityBody: "Tus últimos movimientos, sin ruido.",
    refineLabel: "Refina la lista",
    noStructuredFilters: "Encuentra rápido.",
    activeFiltersCount: "{{count}} filtros activos",
    filterToggle: "Filtros",
    filterAllTypes: "Todos",
    typeFilterLabel: "Tipo de movimiento",
    clearAllFilters: "Limpiar todo",
    removeFilter: "Quitar {{label}}",
    groupSelectedCount: "{{count}} seleccionados",
    noFilterMatches: "Sin resultados",
    allAccounts: "Todas",
    allCategories: "Todas",
    allTags: "Todos",
    allInstallments: "Todas",
    allSavingPlans: "Todas",
    allSavingPockets: "Todos",
    multiAccountsSelected: "{{count}} cuentas",
    multiCategoriesSelected: "{{count}} categorías",
    multiTagsSelected: "{{count}} tags",
    multiInstallmentsSelected: "{{count}} cuotas",
    multiSavingPlansSelected: "{{count}} metas",
    multiSavingPocketsSelected: "{{count}} apartados",
    filtersLabel: "Buscar y filtrar",
    countLabel: "{{count}} movimientos",
    emptyStateBody: "No encontramos movimientos con esos filtros.",
    heroOutflowContext: "salieron este mes",
    heroIncome: "Ingresos {{amount}}",
    heroExpenses: "Gastos {{amount}}",
    flowSummary: "Flujo",
    incomeLabel: "Ingresos",
    expenseLabel: "Gastos",
    insightLargestMovement: "{{name}} fue tu movimiento más grande",
    insightLargestIncome: "Mayor ingreso: {{name}} · {{amount}}",
    insightLargestExpense: "Mayor egreso: {{name}} · {{amount}}",
    jerryInsightLabel: "Una mirada de Jerry",
    insightNoIncome: "Mayor ingreso: sin movimientos",
    insightNoExpense: "Mayor egreso: sin movimientos",
    insightRecentExpense: "Tu gasto más reciente fue {{name}}",
    insightTodayHeavy: "Hoy gastaste más de lo normal",
    insightIncome: "Hubo un ingreso importante recientemente",
    insightExpense: "{{name}} fue de los gastos que más pesaron",
    insightCalm: "Tus gastos están tranquilos esta semana",
    group: {
      today: "Hoy",
      yesterday: "Ayer",
      week: "Esta semana",
      earlier: "Antes",
    },
    activityTypeInflow: "Ingreso",
    activityTypeOutflow: "Gasto",
    activityTypeTransfer: "Transferencia",
    viewMore: "Ver más movimientos",
    totalInflow: "Ingreso total",
    totalOutflow: "Gasto total",
    netPosition: "Posición neta",
    largestOutflowCategory: "Categoría con mayor gasto",
    topInflowAccount: "Cuenta con mayor ingreso",
    recurringMovements: "Movimientos recurrentes",
    editMovement: "Editar movimiento",
    recordMovement: "Registrar movimiento",
    ticket: "Ticket",
    updateSelected: "Actualizar",
    applyChanges: "Aplicar mismos cambios a {{count}} movimiento",
    applyChanges_plural: "Aplicar mismos cambios a {{count}} movimientos",
    selectedCount: "{{count}} seleccionados",
    tapToSelect: "Toca movimientos para seleccionar",
    deleteSelectedPrompt: "¿Seguro que quieres eliminar movimientos seleccionados? Esta acción no se puede deshacer.",
    updateSelectedCta: "Actualizar seleccionados",
    selectOneField: "Selecciona al menos un campo para actualizar.",
    noChange: "Sin cambios",
    transactionDate: "Fecha del movimiento",
    installment: "Cuota",
    savingPlan: "Meta de ahorro",
    savingPocket: "Apartado de ahorro",
    account: "Cuenta",
    sortLabel: "Ordenar",
    sortDateDesc: "Fecha ↓",
    sortDateAsc: "Fecha ↑",
    sortAmountDesc: "Monto ↓",
    sortAmountAsc: "Monto ↑",
    toolbarLabel: "Herramientas de movimientos",
    movementDetail: "Movimiento",
    detailFactsLabel: "Datos del movimiento",
    noteLabel: "Nota",
    receiptLabel: "Comprobante",
    deleteTitle: "¿Eliminar este movimiento?",
    deleteBalanceUp: "Tu saldo de {{account}} sube {{amount}}.",
    deleteBalanceDown: "Tu saldo de {{account}} baja {{amount}}.",
    deleteBalanceTransfer: "Esta transferencia dejará de contar en tus saldos.",
    deletedToast: "Movimiento eliminado",
    createdToast: "Movimiento registrado",
    undoAction: "Deshacer",
    deleteFailed: "No pudimos eliminar el movimiento.",
    retry: "Reintentar",
    loadErrorTitle: "No pudimos cargar tus movimientos",
    loadErrorBody: "Revisa tu conexión e inténtalo de nuevo.",
    emptyTitle: "Aún no tienes movimientos",
    emptyBody: "Registra tu primer ingreso o gasto para empezar a ver tu flujo.",
    newMovement: "Nuevo movimiento",
    createMovement: "Crear movimiento",
  },
  savingPockets: {
    title: "Apartados de ahorro",
    subtitle: "Administra instituciones y apartados de ahorro conectados a tus endpoints de ahorro.",
    creationType: "Qué quieres agregar",
    totalSaved: "Total ahorrado",
    expectedMonthlyReturn: "Retorno mensual esperado",
    activeInstitutions: "Instituciones activas",
    loading: "Cargando datos de apartados de ahorro...",
    loadError: "No se pudieron cargar los datos de apartados de ahorro.",
    none: "Ninguno",
    addInstitution: "Agregar institución",
    editInstitution: "Editar institución",
    institutionEditHint: "Actualiza el nombre y notas de la institución.",
    saveInstitution: "Guardar institución",
    createInstitution: "Crear institución",
    institutionName: "Nombre de institución",
    institutionPlaceholder: "Nubank, Cetes, GBM",
    institution: "Institución",
    institutions: "Instituciones",
    description: "Descripción",
    descriptionPlaceholder: "Notas o contexto opcional",
    addPocket: "Agregar pocket",
    editPocket: "Editar pocket",
    savePocket: "Guardar pocket",
    createPocket: "Crear pocket",
    pocketName: "Nombre del pocket",
    pocketPlaceholder: "Fondo de emergencia",
    amount: "Monto",
    annualRate: "Tasa anual",
    freezeTime: "Tiempo congelado",
    startingDate: "Fecha de inicio",
    freezePlaceholder: "30",
    freezePresetDays: "{{count}} días",
    freezePresetOther: "Otro",
    days: "días",
    freezeReturn: "Retorno al descongelar",
    finalAmount: "Monto final",
    monthlyReturn: "Retorno mensual",
    yearlyReturn: "Retorno anual",
    unfreezeDate: "Fecha de desbloqueo",
    returnAmountAfterFreeze: "Regresar monto al descongelar",
    distributionTitle: "Distribución por institución",
    distributionSubtitle: "Mira cómo se reparte tu dinero entre instituciones.",
    pockets: "Apartados de ahorro",
    pocketCount: "apartados",
    unifySavings: "Unificar ahorros",
    unifySavingsHint: "Agrupa apartados por institución para ver el total consolidado.",
    redesignHint: "Vista más clara para editar, comparar y revisar cada apartado o total por institución.",
    nextUnfreeze: "Próximo desbloqueo: {{date}}",
    formHint: "Agrega un apartado con monto, tasa, tiempo congelado e institución.",
    deleteInstitutionPrompt: "¿Eliminar la institución {{name}}?",
    deletePocketPrompt: "¿Eliminar el apartado {{name}}?",
    modalTitle: "Crear elementos de apartados de ahorro",
    modalSubtitle: "Usa los campos que piden los requests de institutions y apartados para crearlos rápido.",
    activeLabel: "Activo",
  },
  savings: {
    newGoalSubtitle: "Ahorra para algo concreto",
    optionalSection: "Opcional",
    loadError: "No se pudieron cargar tus ahorros.",
    title: "Hey, Ahorros!",
    subtitle: "Así van tus metas",
    closestToGoal: "Más cerca de meta",
    completedGoals: "Metas completadas",
    soonestTarget: "Meta más próxima",
    noSavingsGoalYet: "Aún no hay meta de ahorro",
    noCompletedGoalsYet: "Aún no hay metas completadas",
    goalsReachedTarget: "{{count}} metas alcanzaron objetivo",
    noTargetDateSet: "No hay fecha objetivo",
    allocatedToTargets: "Ahorrado",
    cycleAllocation: "Este ciclo",
    activeTargets: "Metas activas",
    noTargetsYet: "Aún no hay metas financieras",
    createFirstTarget: "Crea tu primera meta",
    emptyStateBody: "Tus metas van a aparecer aquí. Empieza con una y deja que el progreso haga resto.",
    heroDelta: "+{{amount}} este ciclo",
    heroContext: "en {{count}} metas activas",
    heroContextCompleted: "{{count}} metas completadas",
    insightJapanTrip: "Japón",
    insightNearlyDone: "Solo te falta {{percent}} para {{name}}",
    insightRemaining: "Te faltan {{amount}} para completar {{name}}",
    insightAllDone: "Todas tus metas activas ya están listas",
    secondarySummary: "{{count}} metas activas • {{amount}}/mes",
    activeGoalsTitle: "Tus metas",
    goalActionsTitle: "Acciones para {{name}}",
    goalActionsHint: "Desliza a la izquierda o mantén presionada una meta para editarla o eliminarla.",
    completedSectionTitle: "Completadas ({{count}})",
    completedItem: "{{name}} (completada)",
    tableTitle: "Tabla de ahorros",
    tableSubtitle: "Ordenada por mayor avance para dejar metas cercanas arriba.",
    goalsCount: "{{count}} metas",
    goal: "Meta",
    primaryGoal: "Meta principal",
    completedGoals_one: "{{count}} meta completada",
    completedGoals_other: "{{count}} metas completadas",
    goalTargetDate: "Meta para el",
    targetDate: "Fecha objetivo",
    noTargetDate: "Sin fecha objetivo",
    monthlyNeeded: "Necesitas {{amount}} / mes",
    monthlyNeededNoDate: "Define fecha objetivo para estimar monto mensual",
    saved: "Ahorrado",
    target: "Objetivo",
    of: "de",
    remaining: "Restante",
    missingAmount: "Faltan",
    progress: "Avance",
    statusCompleted: "Completada",
    statusInProgress: "En progreso",
    editGoal: "Editar meta de ahorro",
    createGoal: "Crear meta de ahorro",
    modalSubtitle: "Define objetivo y sigue tu avance",
    savingPlanName: "Nombre de meta",
    savingNamePlaceholder: "ej. MacBook Pro, Vacaciones",
    initialAmount: "Monto inicial",
    initialAmountHelp: "Saldo inicial de esta meta",
    targetAmount: "Monto objetivo",
    targetAmountHelp: "Monto meta que quieres alcanzar",
    expectedDate: "Fecha esperada",
    expectedDateHelp: "¿Cuándo planeas llegar a esta meta?",
    descriptionPlaceholder: "¿Para qué es esta meta? (opcional)",
    createGoalAction: "Crear meta",
    totalSavedKicker: "Total ahorrado · {{goals}}",
    remainingForGoals: "Falta para tus metas",
    monthlyContributionNeeded: "Aporte mensual para llegar a tiempo",
    searchGoal: "Buscar meta",
    filterToolbarLabel: "Buscar, filtrar por estado y ordenar metas",
    filterStatusLabel: "Estado: {{value}}",
    filterStatusAria: "Filtrar metas por estado",
    statusFilterAll: "Todas",
    statusFilterInProgress: "En curso",
    statusFilterCompleted: "Completadas",
    sortByLabel: "Ordenar metas",
    sortDueAsc: "Vence ↑",
    sortDueDesc: "Vence ↓",
    sortProgressDesc: "Progreso ↓",
    sortNameAsc: "Nombre A–Z",
    sortNameDesc: "Nombre Z–A",
    listSummary: "{{inProgress}} · {{completed}}",
    inProgressCount: "{{count}} en curso",
    completedShort_one: "{{count}} completada",
    completedShort_other: "{{count}} completadas",
    dueDate: "Vence {{date}}",
    goalAmountLine: "{{saved}} de {{target}}",
    goalAmountMissingLine: "{{saved}} de {{target}} · faltan {{missing}}",
    achievedCaption: "lograda",
    contribute: "Aportar",
    adjustContribution: "Ajustar aporte",
    insightLabel: "Insight de Jerry",
    emptyStateTitle: "Aún no tienes metas",
    emptyStateNewBody: "Crea tu primera meta y deja que el progreso haga el resto.",
  },
  budget: {
    transactionsPeriod: "Movimientos del presupuesto",
    periodBalance: "Presupuesto restante",
    transactionsList: "Movimientos",
    transactionsByCategory: "Por categoría",
    transactionsLoadError: "No se pudieron cargar movimientos.",
    noTransactionsInPeriod: "No hay movimientos en este periodo.",
    transactionsCount: "{{count}} movimientos",
    uncategorized: "Sin categoría",
    title: "Hey, Presupuestos!",
    subtitle: "Cómo vas vs tus límites",
    mostUtilized: "Presupuesto más usado",
    overLimit: "Presupuestos excedidos",
    largestOverspend: "Mayor sobregasto",
    newBudget: "Nuevo presupuesto",
    editBudget: "Editar presupuesto",
    newBudgetSubtitle: "Un límite mensual por categoría",
    createBudget: "Crear presupuesto",
    principalSection: "Principal",
    monthlyLimit: "Límite mensual",
    selectCategory: "Selecciona una categoría",
    alreadyAssigned: " (Ya tiene presupuesto)",
    amountMustBePositive: "Ingresa un monto mayor a 0.",
    saveError: "No se pudo guardar el presupuesto. Intenta de nuevo.",
    searchPlaceholder: "Buscar presupuesto",
    cycleCurrent: "Ciclo: Actual",
    cycleLast: "Ciclo: Anterior",
    cycleCustom: "Ciclo: Personalizado",
    sortUsage: "Uso",
    noBudgetUsageYet: "Aún no hay uso de presupuesto",
    overLimitValue: "{{count}} presupuestos excedieron su límite",
    noBudgetsOverLimit: "No hay presupuestos excedidos",
    noOverspendDetected: "No se detectó sobregasto",
    heroRemaining: "Te quedan {{amount}}",
    heroRemainingPrefix: "Te quedan",
    heroOfBudget: "de tu presupuesto",
    heroRemainingSubtitle: "te quedan de presupuesto",
    heroOverspent: "Pasaste tu límite por {{amount}}",
    heroOverspentPrefix: "Pasaste tu límite por",
    heroOverspentContext: "de más este ciclo",
    heroTotalAssigned: "Presupuesto total asignado: <strong>{{amount}}</strong>",
    insightOver_one: "Ya te pasaste en {{count}} categoría",
    insightOver_other: "Ya te pasaste en {{count}} categorías",
    insightNear: "Algunas categorías ya están cerca del límite",
    insightSafe: "Vas bien con tu presupuesto este mes",
    jerryTipLabel: "Consejo de Jerry",
    allClear: "{{count}} presupuestos. Todo va dentro de su umbral.",
    emptyStateBody: "Tus presupuestos van a aparecer aquí cuando definas un límite por categoría.",
    addFirst: "Crea tu primer presupuesto",
    listTitle: "Lo que pide atención",
    belowThresholdTitle: "Debajo del umbral",
    viewAll: "Ver todos",
    countLabel: "{{count}} presupuestos",
    budgetActionsTitle: "Acciones para {{name}}",
    budgetActionsHint: "Desliza a la izquierda o mantén presionado para editar o eliminar.",
    itemUsage: "Ya usaste {{percent}}%",
    ofLimit: "de",
    itemSpentSummary: "Gastado {{range}} · {{detail}}",
    itemOverDetail: "Excedido por {{amount}}",
    itemNearDetail: "Restan {{amount}}",
    itemSafeDetail: "Restan {{amount}}",
    remainingLabel: "restan",
    exceededLabel: "excedido",
    statusInControl: "✓ Debajo del umbral",
    statusNearLimit: "! Cerca del umbral",
    statusExceeded: "✕ Sobre el umbral",
    amountCents: "Centavos",
    jerryTipAction: "Asignar",
    loadError: "Error al cargar presupuestos: {{message}}",
  },
  installments: {
    newInstallmentSubtitle: "Compra a meses",
    interestRateHelpShort: "Déjala en 0 si es sin intereses. Puedes completarla después.",
    detailsSection: "Detalles",
    title: "Hey, Cuotas!",
    subtitle: "Próximos cargos",
    heroContext: "en pagos próximos",
    heroUpcomingPayments: "Pagos mensuales próximos",
    heroOutstandingBold: "Deuda pendiente total: <strong>{{amount}}</strong>",
    interestNoteTitle: "Intereses pendientes",
    interestNoteBody: "Faltan tasas por capturar.",
    accountFilterValue: "Cuenta: {{value}}",
    allAccountsShort: "Todas",
    filterToolbarLabel: "Buscar, filtrar por cuenta y ordenar cuotas",
    sortNextAsc: "Próx. cobro ↑",
    sortNextDesc: "Próx. cobro ↓",
    sortNameAsc: "Nombre A–Z",
    sortNameDesc: "Nombre Z–A",
    perMonthSuffix: "/mes",
    cardMenuLabel: "Más opciones de {{name}}",
    paidProgress: "{{percent}}% pagado",
    heroInsight: "{{amount}} destinados más adelante",
    heroInsightShort: "El pago fuerte viene esta semana",
    debtByAccountLabel: "Por cuenta",
    debtByAccountTitle: "Deuda pendiente",
    highestMonthlyPayment: "Pago mensual más alto",
    soonestPayoff: "Liquidación más próxima",
    completedInstallments: "Cuotas completadas",
    activeInstallments: "Cuotas activas",
    editInstallment: "Editar cuota",
    newInstallment: "Nueva cuota",
    loading: "Cargando cuotas...",
    loadError: "Error al cargar cuotas.",
    noActiveInstallments: "No hay cuotas activas",
    noPayoffDateYet: "Aún no hay fecha de liquidación",
    noCompletedInstallments: "Aún no hay cuotas completadas",
    completedCount: "{{count}} cuotas marcadas como completas",
    installmentsCount_one: "{{count}} cuota",
    installmentsCount_other: "{{count}} cuotas",
    noInstallmentsFound: "No se encontraron cuotas",
    emptyStateBody: "Tus próximos pagos van a aparecer aquí cuando agregues cuotas.",
    adjustFilters: "Prueba ajustando filtros o búsqueda",
    tableTitle: "Tabla de cuotas",
    listTitle: "Tus próximos pagos",
    sortedBy: "Ordenada por {{label}}.",
    sortByLabel: "Ordenar por",
    sortPayoffSoon: "liquidación más próxima",
    sortHighestMonthly: "pago mensual más alto",
    sortHighestPending: "saldo pendiente más alto",
    itemsCount: "{{count}} elementos",
    viewAll: "Ver todos",
    allStatuses: "Todos los estados",
    statusActive: "Activo",
    statusCompleted: "Completado",
    statusAll: "Todos los estados",
    tableHeaderInstallment: "Cuota",
    tableHeaderOpen: "Abrir",
    monthly: "Mensual",
    totalAmount: "Total",
    remaining: "Restante",
    payoff: "Liquidación",
    nextCharge: "Siguiente cobro",
    payoffDate: "Fecha de liquidación",
    progress: "Avance",
    paidLabel: "Pagado",
    paidCount: "{{paid}} / {{total}} pagados",
    payments: "pagos",
    paymentsCount: "{{count}} pagos",
    perMonth: "por mes",
    allAccounts: "Todas las cuentas",
    accountsSelectedCount: "{{count}} seleccionadas",
    searchPlaceholder: "Busca por nombre o comercio...",
    paymentSchedule: "Calendario de pagos",
    pending: "Pendiente",
    todayCharge: "Siguiente cobro: hoy",
    chargeDate: "Siguiente cobro: {{date}}",
    chargeDatePending: "Siguiente cobro por definir",
    insightWeekMany: "Tienes varios pagos esta semana",
    insightInstallments: "La mayor parte de tus pagos son a meses",
    insightMonthHeavy: "Tus cargos fijos se cargan más en lo que queda del mes",
    insightCalm: "Tus pagos vienen más repartidos por fecha",
    pressureWeek: "Esta semana tienes {{amount}} en pagos",
    pressureMonth: "Este mes todavía te faltan {{amount}} en pagos",
    pressureLater: "Más adelante vienen {{amount}} en pagos",
    typeInstallments: "Te quedan {{count}} pagos",
    remainingPayments: "{{count}} pagos restantes",
    remainingShort: "Restan {{amount}}",
    totalShort: "Total {{amount}}",
    typeFixed: "Pago fijo",
    group: {
      today: "Hoy",
      week: "Esta semana",
      month: "Este mes",
      later: "Más adelante",
    },
    coreDetails: "Detalles base",
    coreDetailsHelp: "Empieza con datos clave para que cuota quede válido y listo para seguimiento.",
    amountsAndTerms: "Montos y plazos",
    amountsAndTermsHelp: "Captura saldos, avance de pagos y detalle útil para esta cuota.",
    notes: "Notas",
    notesHelp: "Agrega contexto opcional para identificar y revisar cuota después.",
    namePlaceholder: "ej. MacBook Pro M5",
    startDate: "Fecha inicial",
    installments: "Mensualidades",
    annualInterestRate: "Tasa de interés anual (%)",
    interestRateHelp: "Déjala vacía si no la conoces; usa 0 si es a meses sin intereses.",
    interestRateInvalid: "Escribe un número mayor o igual a 0.",
    interestRateMissing: "Sin tasa · complétala",
    interestRateKnown: "{{rate}} anual",
    totalInterest: "Intereses totales",
    remainingInterest: "Intereses pendientes",
    interestUnknown: "No disponible",
    initialAmount: "Monto inicial",
    donePayments: "Pagos realizados",
    active: "Activo",
    createInstallment: "Crear cuota",
    saveChanges: "Guardar cambios",
    formProgress: "Progreso del formulario",
    chat: {
    historyTitle: "Historial",
    newConversation: "Nueva conversación",
    today: "Hoy",
    yesterday: "Ayer",
    independentQuestionsNotice: "Cada pregunta se responde por separado.",
      trigger: "Pregúntale a Jerry",
      triggerShort: "Jerry",
      title: "Pregúntame sobre {{domain}}",
      subtitle: "Consulta y entiende mejor la información de {{domain}}.",
      intro: "Puedo ayudarte a analizar tus datos actuales de {{domain}} y responder preguntas concretas.",
      suggestionsLabel: "Puedes empezar por aquí",
      askAnotherLabel: "También puedes preguntar",
      suggestionFirst: "¿Cuál de mis cuotas termino de pagar primero?",
      suggestionMonthly: "¿Cuánto pago al mes entre todos mis cuotas?",
      suggestionLargest: "¿Dónde tengo el mayor saldo pendiente?",
      inputLabel: "Pregunta sobre {{domain}}",
      inputPlaceholder: "Escribe otra pregunta...",
      keyboardHint: "Enter para enviar · Mayús + Enter para una línea nueva",
      send: "Enviar pregunta",
    loading: "Revisando {{domain}}...",
      answerLabel: "Jerry",
      recommendationsLabel: "Recomendaciones",
      summaryLabel: "En resumen",
      retry: "Intentar de nuevo",
      errorValidation: "La pregunta no es válida. Revísala e intenta de nuevo.",
      errorProcessing: "No se pudo procesar la respuesta. Intenta de nuevo.",
      errorUnavailable: "El asistente no está disponible por el momento. Intenta de nuevo en unos minutos.",
      errorNetwork: "No se pudo conectar con el asistente. Revisa tu conexión e intenta de nuevo.",
      errorUnknown: "No se pudo responder la pregunta. Intenta de nuevo.",
      domainNames: {
        transactions: "tus movimientos",
        accounts: "tus cuentas",
        budgets: "tus presupuestos",
        categories: "tus categorías",
        tags: "tus tags",
        installments: "tus cuotas",
        savings: "tus ahorros",
      },
      domainSuggestions: {
        transactions: {
          first: "¿En qué he gastado más recientemente?",
          second: "¿Cuáles son mis movimientos más importantes?",
          third: "¿Qué patrones ves en mis ingresos y gastos?",
        },
        accounts: {
          first: "¿Cuál cuenta tiene el saldo más alto?",
          second: "¿Cómo se distribuye mi dinero entre mis cuentas?",
          third: "¿Qué cuenta requiere más atención?",
        },
        budgets: {
          first: "¿En qué presupuesto estoy más cerca del límite?",
          second: "¿Qué presupuesto debería ajustar primero?",
          third: "¿Dónde todavía tengo margen disponible?",
        },
        categories: {
          first: "¿En qué categorías gasto más?",
          second: "¿Qué categoría cambió más este periodo?",
          third: "¿Cómo se distribuyen mis ingresos por categoría?",
        },
        tags: {
          first: "¿Qué tags concentran más gastos?",
          second: "¿Qué tag uso con mayor frecuencia?",
          third: "¿Qué patrones encuentras entre mis tags?",
        },
        installments: {
          first: "¿Cuál de mis cuotas termino de pagar primero?",
          second: "¿Cuánto pago al mes entre todos mis cuotas?",
          third: "¿Dónde tengo el mayor saldo pendiente?",
        },
        savings: {
          first: "¿Cuál meta de ahorro está más cerca de completarse?",
          second: "¿Cuánto necesito ahorrar al mes?",
          third: "¿Qué plan de ahorro requiere más atención?",
        },
      },
    },
  },
  analytics: {
    viewSummary: "Resumen",
    viewCategories: "Categorías",
    viewFlow: "Flujo",
    viewInstallments: "Cuotas",
    viewSubtitle: {
      summary: "Cómo vas en este ciclo",
      categories: "En qué categorías se va tu gasto",
      flow: "Cómo se mueve una categoría mes a mes",
      installments: "Lo que debes y pagas cada mes en cuotas",
    },
    cycleButtonLabel: "Ciclo: {{cycle}}",
    cycleMenuLabel: "Elegir ciclo",
    summaryHeroLabel: "Tu resumen del ciclo",
    heroSummary: "Gastaste {{amount}} este ciclo. Usaste {{percent}}% de tu presupuesto.",
    heroSummaryNoBudget: "Gastaste {{amount}} este ciclo.",
    budgetUsedNote: "{{percent}}% usado",
    splitSectionTitle: "¿En qué se va tu gasto?",
    splitSectionSubtitle: "Lo comprometido y lo que aún puedes decidir",
    splitCommittedNote: "Cuotas ya contratadas",
    splitPercentOfSpend: "{{percent}}% del gasto",
    title: "Analítica",
    subtitle:
      "Entiende dónde se te va el dinero, qué categorías te sacan de presupuesto y qué revisar primero.",
    monthlyReadingLabel: "Lectura financiera mensual",
    cycleMonthLabel: "Mes a analizar",
    cycleCustomMonth: "Otro mes",
    executiveSummaryLabel: "Resumen ejecutivo",
    committedSpendLabel: "Gasto del ciclo",
    committedSpendTitle: "Comprometido vs. discrecional",
    committedSpendSubtitle: "Cuánto de tu gasto todavía puedes decidir",
    committedLabel: "Comprometido",
    discretionaryLabel: "Discrecional",
    committedDetail: "Cuotas ya contratadas · {{percent}}% del gasto",
    discretionaryDetail: "Lo que sí puedes ajustar este ciclo",
    savedAsideChip: "{{amount}} apartado a ahorro",
    movementChip: "{{amount}} movido entre tus cuentas",
    reduceDiscretionaryCategory: "Recorta {{amount}} en {{category}} para volver a tu presupuesto",
    discretionaryActionHint: "{{count}} categorías discrecionales sobre presupuesto, {{amount}} en total",
    discretionaryOnTrack: "Tu gasto discrecional va dentro de presupuesto este ciclo.",
    unbudgetedSpendHint: "{{amount}} de gasto discrecional no tiene presupuesto asignado.",
    totalExpenseKpi: "Gasto del ciclo",
    totalIncomeKpi: "Ingreso del ciclo",
    totalBudgetKpi: "Presupuesto total",
    sectionFlowTitle: "Este ciclo",
    sectionFlowSubtitle: "Lo que se movió en el periodo seleccionado.",
    sectionPositionTitle: "Posición",
    sectionPositionSubtitle: "Lo que tienes acumulado hoy, sin importar el ciclo.",
    windowToDate: "A la fecha",
    visibleTotalLabel: "Visible",
    metricToggleLabel: "Métrica a visualizar",
    accountOverviewLabel: "Vista de cuentas",
    accountsCount: "{{count}} cuentas",
    installmentsOverviewLabel: "Vista de cuotas",
    installmentsCount: "{{count}} cuotas",
    loading: "Cargando analítica...",
    categoryPyramid: "Pirámide por categoría",
    categoryPyramidSubtitle: "Gastos (izquierda) vs Depósitos (derecha)",
    expenses: "Gastos",
    deposits: "Depósitos",
    expenseByCategory: "Gasto por categoría",
    expenseByCategorySubtitle: "Qué categorías están empujando tu gasto este ciclo",
    incomeByCategory: "Ingreso por categoría",
    incomeByCategorySubtitle: "Qué categorías están impulsando tus ingresos este ciclo",
    expenseByAccount: "Gasto por cuenta",
    expenseByAccountSubtitle: "Cómo se distribuye el gasto total entre tus cuentas",
    incomeByAccount: "Ingreso por cuenta",
    incomeByAccountSubtitle: "Cómo se distribuye el ingreso total entre tus cuentas",
    expenseMetric: "Gastos",
    incomeMetric: "Ingresos",
    installmentsByPending: "Cuotas por monto pendiente",
    installmentsByPendingSubtitle:
      "Qué cuotas todavía concentran el mayor saldo pendiente",
    installmentsChartTitle: "Cuotas",
    installmentsChartSubtitle:
      "Saldos pendientes y pagos mensuales en una sola vista",
    installmentInterestPendingLabel: "Intereses todavía pendientes",
    installmentInterestPendingSubtitle: "Intereses incluidos en tus cuotas pendientes",
    installmentInterestPendingUnknown: "Tasas incompletas",
    installmentsListTitle: "Cuotas que alimentan ambas gráficas",
    installmentsListSubtitle:
      "Selecciona una cuota para quitarla o restaurarla en su gráfica.",
    activeInstallmentsChart: "Saldo restante",
    activeInstallmentsChartSubtitle:
      "Cuánto falta por pagar en total de cada cuota incompleta",
    monthlyInstallmentsChart: "Cuota mensual",
    monthlyInstallmentsChartSubtitle:
      "Cuánto pagas cada mes por cada cuota incompleta",
    installmentsAmountPair: "{{monthly}} / {{remaining}}",
    installmentsAmountPairLegend: "Cuota mensual / saldo restante",
    completedInstallmentsChart: "Cuotas completadas",
    completedInstallmentsChartSubtitle:
      "Qué cuotas saldadas concentran los mayores montos completados",
    activeStatusLabel: "Activo",
    completedStatusLabel: "Completado",
    noActivity: "Aún no hay actividad por categoría para graficar.",
    noVisibleCategories: "Selecciona al menos una categoría para ver la gráfica.",
    noVisibleItems: "Selecciona al menos un elemento para ver la gráfica.",
    topIssueLabel: "Principal problema",
    topIssueValue: "{{label}}: {{category}} (+{{amount}} sobre presupuesto)",
    reviewNudge: "Empieza revisando tus categorías con mayor sobrepresupuesto",
    reviewNudgeTop: "Empieza por {{category}}. Ahí está tu mayor fuga.",
    savingsDistributionEyebrow: "Distribución de savings",
    savingsDistributionTitle: "Savings por institución",
    savingsDistributionSubtitle: "La distribución de savings pocket vive aquí para centralizar asignación en analytics.",
    savingsInstitutionsCount: "{{count}} instituciones",
    reviewTopIssueCta: "Revisar gastos en {{category}}",
    noBudget: "Sin presupuesto",
    nearLimitLabel: "Cerca del límite",
    budgetUsedLabel: "{{percent}}% usado",
    budgetUsageValue: "{{percent}}% del presupuesto",
    budgetOfLabel: "del presupuesto",
    overBudgetLabel: "+{{amount}} sobre presupuesto",
    overBudgetShortLabel: "sobre presupuesto",
    noBudgetDetailShort: "Sin límite definido",
    vsPreviousCycle: "{{change}} vs ciclo anterior",
    viewDetails: "Ver detalle",
    categoryDetailSubtitle: "Qué pasó en esta categoría durante el periodo seleccionado",
    ofSpend: "del gasto",
    amountSpent: "Monto gastado",
    budgetAlertLabel: "Alerta de presupuesto",
    budgetSummaryLabel: "Bloque principal",
    budgetMetric: "Presupuesto",
    overBudgetHeadline: "Vas {{amount}} sobre presupuesto",
    aboveLimitHeadline: "Esto es {{percent}}% arriba de tu límite",
    aboveLimitHeadlineCompact: "+{{percent}}% vs tu límite mensual",
    editBudget: "Editar presupuesto",
    setBudget: "Definir presupuesto",
    remainingBudget: "Presupuesto restante",
    remainingBudgetShort: "Te quedan {{amount}}",
    overUnderStatus: "Estado",
    overBudgetState: "{{amount}} sobre presupuesto",
    withinBudgetState: "Dentro del presupuesto",
    noBudgetDetail: "Esta categoría tiene gasto pero aún no tiene un límite de presupuesto.",
    humanOverBudget: "Te pasaste por {{amount}}",
    budgetUsageMultiple: "{{multiple}} tu presupuesto",
    usedFullBudget: "Usaste todo tu presupuesto",
    statusOverBudget: "Sobre presupuesto",
    statusNearLimit: "Cerca del límite",
    statusInControl: "En control",
    primaryActionLabel: "Acción principal",
    noLargestChargesAvailable:
      "Aún no hay cargos detallados disponibles para esta categoría.",
    loadingLargestCharges: "Buscando cargos detallados...",
    categoryRankingTitle: "Ranking de categorías",
    categoryRankingSubtitle: "Ordénalo según lo que necesites revisar.",
    categoryRankingIncomeSubtitle: "Ve qué categorías concentran más ingresos.",
    rankingSortLabel: "Ordenar por",
    rankingSort: {
      amount: "Monto",
      overspend: "Sobregiro",
      variance: "Desviación",
    },
    rankingOverspendMeta: "{{amount}} sobre presupuesto",
    rankingNoOverspendMeta: "Dentro de presupuesto",
    rankingVarianceMeta: "{{amount}} vs su promedio",
    rankingNoVarianceMeta: "Sin línea base",
    openCategoryDetail: "Ver detalle de {{category}}",
    categoryTrendTitle: "Flujo mensual por categoría",
    categoryTrendSubtitle: "Sigue gasto e ingreso de una categoría durante los meses recientes.",
    reviewCategoryDetails: "Revisar detalle de la categoría",
    categoryTrendSelectLabel: "Categoría a visualizar",
    expenseSeriesLabel: "Gasto",
    incomeSeriesLabel: "Ingreso",
    trendRangeLabel: "Ventana",
    trendRangeValue: "{{count}} meses",
    latestExpenseLabel: "Último gasto",
    latestIncomeLabel: "Último ingreso",
    averageExpenseLabel: "Gasto promedio",
    averageIncomeLabel: "Ingreso promedio",
    categoryTrendEmptySeries:
      "No se encontró movimiento para la categoría seleccionada en esta ventana de 6 meses.",
    categoryWatchlistTitle: "Tarjetas de seguimiento",
    categoryWatchlistSubtitle:
      "Monto gastado, exceso o restante y acceso directo al detalle.",
    accountsOverline: "Cuentas",
    kindLabel: "Tipo",
    flowSeriesLabel: "Serie",
    flowSeriesBoth: "Ambos",
    toggleSeriesHide: "Quitar {{name}} de la gráfica",
    toggleSeriesShow: "Mostrar {{name}} en la gráfica",
    incompleteRatesTitle: "Tasas incompletas",
    incompleteRatesText: "Faltan tasas por capturar para calcular los intereses pendientes de tus cuotas.",
    hiddenFromChart: "Oculta de la gráfica",
    hiddenCountRestore: "{{count}} ocultas · Restaurar",
    driversTitle: "¿Qué está impulsando esto?",
    driversSubtitle: "Insights calculados sobre por qué esta categoría se desvió",
    driverSingleLargePurchase: "{{amount}} fue una compra grande en esta categoría",
    driverLargePurchaseConcentration:
      "La mayor parte del gasto viene de {{count}} compras grandes",
    driverManySmallPurchases: "Hiciste {{count}} compras pequeñas en esta categoría",
    driverWeekendSpike: "{{percent}} de esta categoría pasó en fin de semana",
    driverRecentSpike: "{{percent}} de esta categoría pasó en los últimos 3 días",
    driverSinglePurchaseFallback: "Esta categoría se explica por una sola compra",
    driverPurchaseCountFallback: "Hiciste {{count}} compras con un promedio de {{average}}",
    suggestedActionsTitle: "Acciones sugeridas",
    driverActionReviewLargest: "Revisa tus movimientos más grandes",
    driverActionSetStricterBudget: "Considera poner un presupuesto más estricto",
    driverActionLimitWeekend: "Limita el gasto en fin de semana",
    driverActionReviewRecent: "Revisa la actividad reciente",
    modalInsightTopOverspend: "Esta categoría concentra el mayor exceso del ciclo",
    modalInsightAboveBudget: "El gasto está {{percent}}% por encima del presupuesto",
    modalInsightBudgetUsage: "Ya consumiste {{percent}}% de tu presupuesto",
    modalInsightShareOfSpend: "Representa {{percent}}% del gasto total",
    noDetailedTransactionsInsight:
      "No hay movimientos detallados disponibles para esta categoría, pero el gasto agregado proviene del resumen del periodo.",
    transactionsTitle: "Movimientos",
    transactionsSubtitle: "Actividad del periodo actual en esta categoría",
    topChargesShareSummary:
      "Tus 3 cargos más grandes representan {{percent}}% de esta categoría",
    topChargeBadge: "Top {{rank}}",
    loadingShort: "Cargando...",
    noTransactionsForCategory: "Aún no hay movimientos individuales para mostrar.",
    noTransactionsForCategoryDetail:
      "El total mostrado viene de datos agregados del periodo.",
    notAvailable: "No disponible",
    saveBudgetError: "No pudimos guardar el presupuesto ahora.",
  },
  transactionModal: {
    sections: {
      principal: "Principal",
      context: "Contexto",
      optional: "Opcional",
    },
    hints: {
      required: "Requerido",
      optional: "Opcional",
    },
    amountCents: "Centavos",
    quickTitle: "Movimiento rápido",
    quickSubtitle: "Registra un gasto en pocos pasos.",
    createQuick: "Crear movimiento",
    quickNamePlaceholder: "Ej. Supermercado",
    quickAmountPlaceholder: "0.00",
    quickNoCategory: "Sin categoría",
    quickSelectAccount: "Selecciona una cuenta",
    quickValidationError: "Completa nombre, monto, fecha y cuenta.",
    quickSubmitError: "No pudimos crear movimiento. Intenta otra vez.",
    newTitle: "Nuevo movimiento",
    editTitle: "Editar movimiento",
    subtitle: "Agrega un movimiento para seguir tus gastos o ingresos",
    coreDetails: "Detalles base",
    coreDetailsHelp: "Ajusta primero campos requeridos para que movimiento quede válido y completo.",
    context: "Contexto",
    contextHelp: "Campos opcionales ayudan a clasificar o vincular movimiento sin ser obligatorios.",
    additionalDetails: "Detalles adicionales",
    additionalDetailsHelp: "Adjunta ticket o deja notas para auditar movimiento después.",
    transactionNamePlaceholder: "ej. Netflix, Supermercado",
    loadingTypes: "Cargando tipos...",
    selectTransactionType: "Selecciona tipo de movimiento",
    loadingAccounts: "Cargando cuentas...",
    accountsAvailable: "{{count}} disponibles",
    noAccountsAvailable: "No hay cuentas disponibles",
    selectAccount: "Selecciona una cuenta",
    noAccountsFound: "No se encontraron cuentas. Crea una cuenta primero.",
    selectDestinationAccount: "Selecciona una cuenta destino",
    noDestinationAccountsAvailable: "No hay cuentas destino disponibles",
    noDestinationAccountsFound: "No hay cuentas destino disponibles. Elige otra cuenta origen.",
    selectCategory: "Selecciona una categoría",
    loadingTags: "Cargando tags...",
    noTagsAvailable: "No hay tags disponibles",
    selectTag: "Selecciona un tag",
    allocateSavingPlan: "Asignar a meta de ahorro",
    unlinkSavingPlan: "Desvincular meta de ahorro",
    linkInstallment: "Vincular a cuota",
    unlinkInstallment: "Desvincular cuota",
    attachReceipt: "Adjuntar ticket",
    removeAttachment: "Quitar comprobante {{name}}",
    chooseFile: "Elegir archivo",
    fileFormats: "JPG, PNG, PDF, DOC (máx 30MB)",
    descriptionPlaceholder: "Agrega cualquier detalle extra de este movimiento...",
    descriptionHelp: "Opcional - agrega cualquier detalle extra",
    mobileContextTitle: "Contexto",
    failedProcessFile: "No pudimos procesar ese archivo. Prueba otra imagen.",
    enterTransactionName: "Ingresa nombre del movimiento",
    enterValidAmount: "Ingresa un monto válido",
    selectAccountError: "Selecciona una cuenta",
    selectDestinationError: "Selecciona una cuenta destino",
    destinationMustDiffer: "Cuenta destino debe ser distinta a cuenta origen",
    selectDateError: "Selecciona una fecha",
    updateTransaction: "Actualizar movimiento",
    createTransaction: "Crear movimiento",
  },
  router: {
    notFoundTitle: "Ruta no encontrada",
    notFoundBody: "Si llegaste aquí, ruta no coincide con ninguna ruta definida en router.",
  },
  terms: {
    home: "Volver a Hey Jerry",
    title: "Términos y condiciones",
    updated: "Última actualización: 20 de agosto de 2026",
    intro: "Estos términos y condiciones explican las reglas para usar Hey Jerry, un espacio de finanzas personales para registrar, organizar y entender tu propia actividad financiera.",
    sections: {
      service: {
        title: "1. El servicio",
        body: "Hey Jerry te ayuda a registrar movimientos, organizar cuentas y categorías, comparar periodos y dar seguimiento a planes como presupuestos, metas de ahorro y cuotas. No se conecta a tu banco, almacena credenciales bancarias, mueve dinero ni realiza pagos.",
      },
      eligibility: {
        title: "2. Elegibilidad",
        body: "Solo puedes usar Hey Jerry si puedes celebrar un acuerdo vinculante conforme a las leyes que te aplican. Si usas el servicio para una organización, confirmas que tienes autorización para aceptar estos términos en su nombre.",
      },
      account: {
        title: "3. Tu cuenta",
        body: "Eres responsable de la información que proporcionas, de mantener tus credenciales confidenciales y de toda actividad realizada desde tu cuenta. Avísanos pronto si crees que alguien usó tu cuenta sin permiso.",
      },
      data: {
        title: "4. Tus datos",
        body: "Tú conservas la responsabilidad sobre la información financiera que ingresas. Autorizas a Hey Jerry a procesarla solo cuando sea necesario para prestar, proteger, mantener y mejorar el servicio. No ingreses información que no tengas permitido usar.",
      },
      use: {
        title: "5. Uso permitido",
        body: "No uses el servicio indebidamente, interfieras con su operación, intentes acceder sin autorización, subas código malicioso ni lo uses para infringir derechos de otras personas o la ley. No trates las cifras de ejemplo o resúmenes generados como registros financieros verificados.",
      },
      availability: {
        title: "6. Disponibilidad y cambios",
        body: "Hey Jerry puede cambiar, suspender o retirar funciones para mantener o mejorar el servicio. Haremos esfuerzos razonables para comunicar cambios relevantes cuando sea posible, pero no garantizamos disponibilidad ininterrumpida.",
      },
      intellectualProperty: {
        title: "7. Propiedad intelectual",
        body: "Hey Jerry y su software, interfaz, marca y contenido original pertenecen a sus respectivos titulares. Estos términos te otorgan un derecho limitado, personal e intransferible para usar el servicio mientras tu cuenta tenga acceso permitido.",
      },
      privacy: {
        title: "8. Privacidad",
        body: "El tratamiento de la información personal se describe en el aviso de privacidad aplicable. Cuando está habilitada, Hey Jerry usa PostHog como proveedor de analítica de producto para entender la navegación y adopción de funciones. Esta analítica usa solo un identificador interno y dimensiones de baja cardinalidad; no envía importes, saldos, nombres de movimientos, prompts, respuestas, correo electrónico, teléfono, tokens ni payloads de API. El SDK no usa autocapture ni session replay y respeta la señal Do Not Track. Estos términos no sustituyen el aviso de privacidad; revisa ambos documentos antes de crear una cuenta.",
      },
      disclaimer: {
        title: "9. Sin asesoría financiera",
        body: "Hey Jerry ofrece herramientas de organización e información, no asesoría financiera, de inversión, fiscal, legal ni contable. Verifica las decisiones y registros importantes con un profesional calificado o con la fuente original.",
      },
      liability: {
        title: "10. Responsabilidad",
        body: "En la medida permitida por la ley, Hey Jerry no es responsable por pérdidas causadas por tus decisiones, información incorrecta que ingreses, interrupciones fuera de nuestro control razonable o falta de protección de tu cuenta.",
      },
      termination: {
        title: "11. Fin del acceso",
        body: "Puedes dejar de usar tu cuenta en cualquier momento. Podemos restringir o terminar el acceso cuando sea necesario para proteger el servicio, cumplir la ley, atender un uso indebido o responder a un incumplimiento material de estos términos.",
      },
      changes: {
        title: "12. Cambios a estos términos",
        body: "Podemos actualizar estos términos cuando cambie el servicio o evolucionen los requisitos legales. La versión actualizada mostrará una nueva fecha. Continuar usando el servicio después de un cambio significa que aceptas los términos actualizados cuando la ley lo permita.",
      },
      contact: {
        title: "13. Preguntas",
        body: "Si tienes preguntas sobre estos términos o tu cuenta, usa el canal de soporte disponible en tu cuenta de Hey Jerry.",
      },
    },
  },
  landing: {
    nav: {
      aria: "Navegación principal",
      sections: "Secciones",
      home: "Hey Jerry, inicio",
      why: "Por qué Jerry",
      how: "Cómo funciona",
      faq: "Preguntas",
      signIn: "Iniciar sesión",
      signUp: "Crear cuenta",
    },
    hero: {
      eyebrow: "Finanzas personales",
      titleLine1: "Dale sentido",
      titleLine2: "a tu dinero.",
      lead: "Jerry no se sincroniza con tu banco, y es a propósito. Tú registras tus movimientos; Jerry los organiza, compara periodos y te devuelve la lectura completa de tu mes.",
      primaryCta: "Empezar con Jerry",
      secondaryCta: "Ver cómo funciona",
      previewAria: "Vista previa del panel de Jerry",
      previewCaption: "Vista de ejemplo",
    },
    preview: {
      sampleData: "Datos de ejemplo",
      window: "Panel",
      balanceLabel: "Balance del periodo",
      balanceValue: "$13,766",
      balanceMeta: "Comparado con el periodo anterior",
      inflowLabel: "Ingresos",
      inflowValue: "$28,400",
      outflowLabel: "Gastos",
      outflowValue: "$14,634",
      breakdownLabel: "Dónde se concentró",
      rows: {
        installments: "Cuotas",
        food: "Alimentos",
        transport: "Transporte",
      },
    },
    manifesto: {
      title: "Entender tus gastos es entender tus decisiones.",
      body: "Una app que importa todo por ti te entrega un historial que nunca leíste. Jerry te pide un gesto pequeño, registrar, y cada número de tu mes tiene una historia que sí recuerdas.",
      benefits: {
        one: {
          title: "Todo tu dinero en un solo lugar",
          copy: "Cuentas, movimientos, categorías y tags. Jerry calcula balances y los cruza para darte una sola lectura del mes.",
        },
        two: {
          title: "Comparaciones del periodo con evidencia",
          copy: "Jerry compara periodos y distribuciones para mostrar qué cambió, sin inventar causas que tus datos no pueden explicar.",
        },
        three: {
          title: "Planes con seguimiento real",
          copy: "Presupuestos, metas de ahorro y cuotas, medidos contra los movimientos que tú registras.",
        },
      },
    },
    process: {
      title: "Del movimiento a la decisión.",
      body: "Jerry organiza lo que pasó, compara periodos y destaca qué conviene revisar. La siguiente acción la eliges tú.",
      steps: {
        one: { kicker: "Tú registras", title: "Movimientos", copy: "Cuentas, compras, ingresos y cuotas." },
        two: { kicker: "Jerry compara", title: "Señales", copy: "Balances, concentraciones y cambios entre periodos." },
        three: { kicker: "Tú decides", title: "Acciones", copy: "Qué ajustar, priorizar o seguir observando." },
      },
    },
    insight: {
      title: "Tus datos se convierten en una lectura clara.",
      body: "Jerry pone balances, cambios y avances al frente para que decidas con calma.",
      allocationLabel: "Distribución del periodo",
      segments: {
        income: "Disponible",
        fixed: "Cuotas",
        flex: "Variable",
      },
      decisions: {
        one: "Cuánto ingresó, salió y quedó en el periodo",
        two: "Qué categorías y tags concentran el movimiento",
        three: "Cómo avanzan tus presupuestos, metas y cuotas",
      },
    },
    faq: {
      title: "Preguntas antes de empezar.",
      body: "Qué hace Jerry hoy, qué depende de tus datos y dónde están sus límites.",
      items: {
        banks: {
          question: "¿Jerry se conecta automáticamente con mis bancos?",
          answer:
            "No, y es una decisión de diseño. Tú creas tus cuentas y registras tus movimientos dentro de Jerry. El efecto secundario importante: Jerry nunca pide ni almacena las credenciales de tu banco, porque no las necesita.",
        },
        analysis: {
          question: "¿Qué puede analizar Jerry con confianza?",
          answer:
            "Los datos que registras: balances, ingresos, gastos, cambios por periodo, distribución por cuenta, categoría o tag, y avance de presupuestos, metas de ahorro y cuotas. Con suficiente historial también muestra comparaciones entre periodos.",
        },
        advice: {
          question: "¿Jerry me dice qué debo hacer?",
          answer:
            "No. Jerry destaca cambios y áreas que conviene revisar; la decisión es tuya. Jerry apoya decisiones, no sustituye asesoría financiera.",
        },
        taxonomy: {
          question: "¿Cuál es la diferencia entre categorías y tags?",
          answer:
            "Una categoría explica qué fue el movimiento y sirve para agrupar gasto o definir un presupuesto, por ejemplo Restaurantes o Transporte. Un tag agrega contexto transversal, por ejemplo Viaje de trabajo, Reembolsable o MSI. Así una compra puede estar en Restaurantes y llevar el tag Viaje de trabajo.",
        },
        autoCategorize: {
          question: "¿Jerry clasifica mis movimientos por sí solo?",
          answer:
            "No. Tú eliges la categoría y, si te sirve, un tag al registrar o editar cada movimiento. Jerry usa esa organización para calcular distribuciones y detectar concentraciones.",
        },
        money: {
          question: "¿Jerry puede mover dinero o pagar mis cuotas?",
          answer:
            "No. Jerry sirve para registrar, organizar, analizar y dar seguimiento. No ejecuta transferencias, cargos ni pagos, y no realiza cambios en tus cuentas bancarias.",
        },
      },
    },
    finalCta: {
      kicker: "Tu dinero, más claro desde hoy",
      title: "Haz espacio para mejores decisiones.",
      body: "Empieza registrando una cuenta. El resto se construye con tu propio mes.",
      cta: "Crear mi cuenta",
    },
    footer: {
      tagline: "Finanzas personales para decidir con claridad.",
      dataNote: "Jerry no se conecta a tu banco ni almacena credenciales bancarias.",
      terms: "Términos y condiciones",
      language: "Idioma",
      theme: "Tema",
      themeLight: "Claro",
      themeDark: "Oscuro",
    },
  },
};
